/* NUANSE Joias, páginas extra (estrutura da referência, texto nosso e verdadeiro).
   ponytail: conteúdo em código; quando houver páginas reais na Shopify, passar para templates/page.*.json */
(function () {
  "use strict";
  var A = function () {
    return window.NZAPP;
  };
  // fotos dos nossos produtos (fornecedor), nunca da referência: [handle, índice da foto]
  var gi = function (k, w) {
    var p = A().P()[k[0]] || A().P()["brincos-colibri"];
    return p ? A().img(p.i[Math.min(k[1], p.i.length - 1)], w || 900) : "";
  };
  var ST = { hero: ["colar-abraco-ao-cao", 0], s2: ["colar-abraco-ao-gato", 0], s3: ["colar-colibri-colorido", 0], s4: ["pulseira-ponte-arco-iris", 0], s5: ["brincos-dente-de-leao", 0], s6: ["colar-pata-coracao-e-infinito", 0], side: ["colar-abraco-ao-cao", 1] };
  var HB = { hero: ["brincos-colibri", 0], gif: ["brincos-colibri", 1], p1: ["brincos-colibri", 2], p2: ["brincos-colibri", 3], gift: ["conjunto-colibri-colar-e-brincos", 0], box: ["brincos-colibri", 4], u1: ["brincos-colibri", 5], u2: ["colar-colibri-colorido", 0], u3: ["colar-colibri-colorido", 1], side: ["colar-colibri-colorido", 2] };
  var HB_PRODUCT = "brincos-colibri";
  function fig(id, alt, ai) {
    return (
      '<figure class="adv__fig' +
      (ai ? " is-ai" : "") +
      '"><img loading="lazy" src="' +
      id +
      '" alt="' +
      (alt || "") +
      '"></figure>'
    );
  }
  function cta(href, label) {
    return (
      '<a class="adv__cta" href="' + href + '" data-link>' + label + " →</a>"
    );
  }
  function side(imgSrc, title, line, href, label) {
    return (
      '<aside class="adv__side"><div class="adv__card"><img loading="lazy" src="' +
      imgSrc +
      '" alt=""><p class="adv__card-t">' +
      title +
      "</p><p>" +
      line +
      "</p>" +
      cta(href, label) +
      "</div></aside>"
    );
  }
  function page(title, body) {
    A().app.innerHTML =
      '<section class="sec page-width pg"><h1 class="pg__t">' +
      title +
      '</h1><div class="pg__b">' +
      body +
      "</div></section>";
  }

  window.NZPAGES = {
    /* A nossa história (estrutura do "My Story" da referência, sem pessoa inventada) */
    "/pages/my-story": {
      adv: true,
      render: function () {
        A().app.innerHTML =
          '<div class="adv"><div class="adv__bar"><a href="/" data-link class="adv__logo"><img src="' +
          NZ.logo +
          '" alt="NUANSE"></a><span>Publicidade · Conteúdo da marca</span></div>' +
          '<div class="adv__wrap"><article class="adv__col">' +
          "<h1>Joias para guardar quem amamos, mesmo depois de partirem</h1>" +
          fig(NZ.hero, "Mulher com três cães num jardim") +
          '<p class="adv__pill">🇵🇹 Enviamos para todo o Portugal · Portes grátis acima de 59 €</p>' +
          "<p>Na NUANSE escolhemos joias com <b>significado</b>. Começámos pelas que lembram os nossos animais, porque quem já perdeu um cão ou um gato sabe que o amor não acaba quando eles partem.</p>" +
          "<p>Um colar com um abraço, uma pata, um colibri. Peças pequenas que dizem uma coisa grande: <b>continuas comigo</b>.</p>" +
          "<h2>Um amor que fica, mesmo depois de partirem</h2>" +
          fig(NZ.about, "Mulher a trabalhar numa joia") +
          "<p>O silêncio da casa depois de um animal partir é das coisas mais difíceis de explicar. Não há latido à porta, não há patas no chão da cozinha.</p>" +
          "<p>Muita gente procura uma forma de guardar essa ligação. Uma fotografia, um nome, um gesto. E, cada vez mais, uma joia que se usa todos os dias.</p>" +
          "<h2>Do luto nasceu o conforto, e do amor nasceram estas joias</h2>" +
          fig(gi(ST.s6), "Colares com patas e corações") +
          "<p>Escolhemos cada peça pelo que representa: o abraço entre uma pessoa e o seu cão, a pata que deixa marca, o colibri que em muitas culturas simboliza quem nos visita depois de partir.</p>" +
          "<p><i>“Foste tudo para mim, e vais continuar a ser.”</i> É isto que estas peças querem dizer, sem precisarem de palavras.</p>" +
          "<h2>Feitas com cuidado, para ti e para quem ainda carregas no coração</h2>" +
          fig(gi(HB.p2), "Brincos de colibri na mão") +
          "<p>Não fabricamos as joias nós mesmos: trabalhamos com fornecedores escolhidos e dizemos sempre de que é feita cada peça. Liga banhada é liga banhada, aço é aço, prata é prata.</p>" +
          "<p>Escolhemos cada peça pela foto e pela opinião de quem já a comprou, e dizemos sempre de que é feita e quanto demora a chegar.</p>" +
          "<h2>Escolhe a peça que fala ao teu coração</h2>" +
          fig(gi(ST.s6), "Colares com patas e corações") +
          "<p><b>Guarda o que importa.</b> Uma joia para ti, ou para alguém que está a passar por uma despedida. Um presente que diz mais do que palavras.</p>" +
          cta("/collections/limited-sale", "VER A COLEÇÃO") +
          "<h2>As nossas promessas</h2>" +
          '<ul class="adv__list"><li>✔ Garantia legal de 3 anos em todas as peças</li><li>✔ 30 dias para devolver, sem explicações</li><li>✔ Material descrito com verdade em cada produto</li><li>✔ Leva 2 com −15% e Leva 3 com −20%</li></ul>' +
          cta("/collections/limited-sale", "VER A COLEÇÃO") +
          '<p class="adv__disc"><b>Aviso:</b> esta página é publicidade da NUANSE. Não é um artigo de imprensa nem uma opinião independente.</p>' +
          "</article>" +
          side(
            gi(ST.side, 600),
            "Encontra a peça que fala ao teu coração",
            "Colares, pulseiras e anéis com significado.",
            "/collections/limited-sale",
            "VER A COLEÇÃO",
          ) +
          "</div></div>";
      },
    },

    /* Colibri (estrutura do advertorial da referência, assumido como publicidade) */
    "/pages/hummingbird-earrings": {
      adv: true,
      render: function () {
        var p = A().P()[HB_PRODUCT],
          price = p ? A().money(p.p) : "";
        var url = "/products/" + HB_PRODUCT;
        A().app.innerHTML =
          '<div class="adv"><div class="adv__top">PUBLICIDADE</div><div class="adv__mast"><b>NUANSE</b> <i>HISTÓRIAS</i></div>' +
          '<div class="adv__wrap"><article class="adv__col">' +
          "<h1>Um pequeno símbolo de força: as joias de colibri que muitas mulheres usam como lembrança</h1>" +
          '<p class="adv__by"><span class="adv__av">N</span>Por <b>equipa NUANSE</b> · conteúdo patrocinado</p>' +
          fig(gi(HB.p1), "Brincos de colibri numa janela") +
          "<p><b>O colibri aparece em muitas histórias como um mensageiro.</b> Em várias culturas da América Latina diz-se que, quando um colibri se aproxima, é alguém que amamos a passar por perto.</p>" +
          "<p>É por isso que tanta gente escolhe estas peças para si ou para oferecer: são leves, coloridas e carregam uma ideia bonita, a de que quem amamos continua por perto.</p>" +
          fig(gi(HB.gif), "Brincos de colibri a brilhar") +
          "<p>As cores mudam com a luz: vermelhos, amarelos, verdes e azuis, como as penas de um colibri a sério.</p>" +
          fig(gi(HB.p1), "Brincos de colibri numa janela") +
          '<h2>Conhece os <span class="adv__hl">Brincos Colibri em Acrílico</span></h2>' +
          fig(gi(HB.p2), "Brincos de colibri na mão") +
          "<p>Desenho de colibri em acrílico colorido, com ganchos em metal. São muito leves, por isso dá para os usar o dia inteiro.</p>" +
          "<h2>Tão práticos como bonitos</h2>" +
          fig(gi(HB.p2), "Brincos de colibri na mão") +
          '<ul class="adv__list"><li>✔ Leves: quase não se sentem na orelha</li><li>✔ Acrílico colorido, não perde a cor com o uso normal</li><li>✔ Seguem prontos a oferecer</li><li>✔ Garantia legal de 3 anos</li></ul>' +
          cta(url, "VER OS BRINCOS") +
          "<h2>Um presente com significado</h2>" +
          fig(NZ.about, "Mulher a trabalhar numa joia") +
          "<p>Para a mãe, para a avó, para uma amiga que está a passar por uma despedida, ou para ti. É um presente pequeno que diz muito.</p>" +
          fig(gi(HB.box), "Brincos colibri") +
          "<h2>Como ficam no dia a dia</h2>" +
          '<div class="adv__grid3">' +
          [HB.u1, HB.u2, HB.u3]
            .map(function (x) {
              return '<img loading="lazy" src="' + gi(x, 500) + '" alt="">';
            })
            .join("") +
          "</div>" +
          '<div class="adv__note">Ainda não temos avaliações destes brincos. Quando as clientes as deixarem, aparecem aqui, tal como foram escritas.</div>' +
          "<h2>Compra hoje com o desconto Leva 2</h2>" +
          fig(gi(HB.p1), "") +
          '<p class="adv__price">' +
          price +
          " · <span>Leva 2 peças e poupa 15%</span></p>" +
          "<p>Junta uns brincos e um colar, ou leva dois pares para oferecer. O desconto aparece sozinho no carrinho, e os portes ficam grátis a partir de 59 €.</p>" +
          cta(url, "VER OS BRINCOS") +
          '<p class="adv__disc"><b>Aviso:</b> esta página é publicidade da NUANSE. Não é um artigo de imprensa.</p>' +
          "</article>" +
          side(
            gi(HB.side, 600),
            "Brincos Colibri em Acrílico",
            "Celebra a tua força com cor. " + price,
            url,
            "VER OS BRINCOS",
          ) +
          "</div></div>";
      },
    },

    "/pages/contact": {
      render: function () {
        A().app.innerHTML =
          '<section class="sec page-width pg pg--form"><h1 class="pg__t">Contacto</h1>' +
          '<form method="post" action="/contact#contact_form" accept-charset="UTF-8" class="cf"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">' +
          '<label>Nome<input name="contact[name]" autocomplete="name"></label>' +
          '<label>Email<input type="email" name="contact[email]" required autocomplete="email"></label>' +
          '<label>Mensagem<textarea name="contact[body]" rows="6"></textarea></label>' +
          '<button class="btn btn--lg" type="submit">Enviar</button></form>' +
          '<p class="cf__note">Respondemos em 24 horas úteis. Também podes escrever para contacto@nuanse.online.</p></section>';
      },
    },

    "/pages/faq-frequently-asked-questions": {
      render: function () {
        var q = [
          ["Em que moeda pago?", "Em euros, com IVA incluído no preço."],
          [
            "Quanto tempo demora a entrega?",
            "Processamos a encomenda em 1 a 3 dias úteis. O transporte demora 8 a 15 dias úteis, porque as peças são enviadas pelo nosso fornecedor fora da UE: no total, 9 a 18 dias úteis. Recebes o código de seguimento por email.",
          ],
          [
            "Como sigo a minha encomenda?",
            "Pelo link do email de envio. Se não o encontrares, escreve-nos e enviamos de novo.",
          ],
          [
            "Qual é a política de devoluções?",
            'Tens 30 dias depois de receber para devolver, sem explicações. Vê a <a href="/policies/refund-policy" data-native>política de devoluções</a>.',
          ],
          [
            "Como vos contacto?",
            'Por email para contacto@nuanse.online ou pelo <a href="/pages/contact" data-link>formulário de contacto</a>.',
          ],
          [
            "Que métodos de pagamento aceitam?",
            "MB WAY, Multibanco, cartão (Visa, Mastercard), Apple Pay e PayPal.",
          ],
          [
            "Vou pagar alfândega?",
            "Não. O preço que vês é o preço final, sem custos extra na entrega.",
          ],
          [
            "Quando recebo o reembolso?",
            "Até 14 dias depois de recebermos a devolução, pelo mesmo método de pagamento.",
          ],
        ];
        page(
          "Perguntas frequentes",
          q
            .map(function (x) {
              return "<h3>" + x[0] + "</h3><p>" + x[1] + "</p>";
            })
            .join(""),
        );
      },
    },

    "/pages/leave-a-review": {
      render: function () {
        A().app.innerHTML =
          '<section class="sec page-width pg rv-page"><h2>Queremos a tua opinião sincera 💬</h2>' +
          "<p>Obrigado por fazeres parte da NUANSE 💗<br>A tua opinião ajuda-nos a escolher melhor cada peça e ajuda outras pessoas a decidir.</p>" +
          "<p>✨ Demora menos de 1 minuto<br>✨ Publicamos todas as avaliações, boas e más, tal como foram escritas<br>✨ Só pedimos avaliações a quem comprou</p>" +
          "<p>Gostaste da tua joia ou achas que podemos fazer melhor? Queremos saber.</p>" +
          '<a class="btn btn--lg" href="/pages/contact" data-link>Começar avaliação →</a></section>';
      },
    },

    "/pages/shipping-delivery": {
      render: function () {
        location.href = "/policies/shipping-policy";
      },
    },
    "/pages/returns-refunds": {
      render: function () {
        location.href = "/policies/refund-policy";
      },
    },
    "/pages/privacy-policy": {
      render: function () {
        location.href = "/policies/privacy-policy";
      },
    },
    "/pages/terms-of-service": {
      render: function () {
        location.href = "/policies/terms-of-service";
      },
    },
  };
  // Reino Unido (inglês): as mesmas páginas, com texto nativo em inglês e regras do mercado UK
  if (!(window.NZL && NZL.en)) return;
  var M = NZL.money;
  ["/pages/shipping-delivery", "/pages/returns-refunds", "/pages/privacy-policy", "/pages/terms-of-service"].forEach(function (k) {
    var to = { "/pages/shipping-delivery": "/policies/shipping-policy", "/pages/returns-refunds": "/policies/refund-policy", "/pages/privacy-policy": "/policies/privacy-policy", "/pages/terms-of-service": "/policies/terms-of-service" }[k];
    NZPAGES[k] = { render: function () { location.href = NZL.u(to); } };
  });
  NZPAGES["/pages/my-story"] = {
    adv: true,
    render: function () {
      A().app.innerHTML =
        '<div class="adv"><div class="adv__bar"><a href="/" data-link class="adv__logo"><img src="' + NZ.logo + '" alt="NUANSE"></a><span>Advertisement · Brand content</span></div>' +
        '<div class="adv__wrap"><article class="adv__col">' +
        "<h1>Jewellery to keep the ones we love close, even after they're gone</h1>" +
        fig(NZ.hero, "Woman with three dogs in a garden") +
        '<p class="adv__pill">🇬🇧 Tracked delivery across the UK · Free delivery over ' + M(NZL.FREE) + "</p>" +
        "<p>At NUANSE we choose jewellery with <b>meaning</b>. We started with pieces that remind us of our animals, because anyone who has lost a dog or a cat knows that love doesn't end when they go.</p>" +
        "<p>A necklace with a hug, a paw, a hummingbird. Small pieces that say something big: <b>you're still with me</b>.</p>" +
        "<h2>A love that stays, even after they're gone</h2>" +
        fig(NZ.about, "Woman working on a piece of jewellery") +
        "<p>The silence of a home after an animal has gone is one of the hardest things to explain. No bark at the door, no paws on the kitchen floor.</p>" +
        "<p>So many people look for a way to hold on to that bond. A photo, a name, a gesture. And, more and more, a piece of jewellery worn every day.</p>" +
        "<h2>Comfort grew out of grief, and these pieces grew out of love</h2>" +
        fig(gi(ST.s6), "Necklaces with paws and hearts") +
        "<p>We choose every piece for what it stands for: the hug between a person and their dog, the paw that leaves its mark, the hummingbird that in many cultures stands for someone visiting us after they've gone.</p>" +
        "<p><i>“You were everything to me, and you always will be.”</i> That's what these pieces are here to say, without needing words.</p>" +
        "<h2>Chosen with care, for you and for the ones you still carry in your heart</h2>" +
        fig(gi(HB.p2), "Hummingbird earrings in a hand") +
        "<p>We don't make the jewellery ourselves: we work with carefully chosen suppliers and always tell you what each piece is made of. Plated alloy is plated alloy, steel is steel, silver is silver.</p>" +
        "<p>We pick every piece by its photos and by the reviews of people who've bought it, and we always tell you what it's made of and how long it takes to arrive.</p>" +
        "<h2>Find the piece that speaks to your heart</h2>" +
        fig(gi(ST.s6), "Necklaces with paws and hearts") +
        "<p><b>Keep what matters.</b> A piece for you, or for someone going through a goodbye. A gift that says more than words.</p>" +
        cta("/collections/limited-sale", "SEE THE COLLECTION") +
        "<h2>Our promises</h2>" +
        '<ul class="adv__list"><li>✔ 3-year guarantee on every piece</li><li>✔ 30 days to return, no questions asked</li><li>✔ Materials described honestly on every product</li><li>✔ Buy 2 for −15% and Buy 3 for −20%</li></ul>' +
        cta("/collections/limited-sale", "SEE THE COLLECTION") +
        '<p class="adv__disc"><b>Please note:</b> this page is an advertisement by NUANSE. It is not a press article or an independent review.</p>' +
        "</article>" +
        side(gi(ST.side, 600), "Find the piece that speaks to your heart", "Necklaces, bracelets and rings with meaning.", "/collections/limited-sale", "SEE THE COLLECTION") +
        "</div></div>";
    },
  };
  NZPAGES["/pages/hummingbird-earrings"] = {
    adv: true,
    render: function () {
      var p = A().P()[HB_PRODUCT], price = p ? M(p.p) : "", url = "/products/" + HB_PRODUCT;
      A().app.innerHTML =
        '<div class="adv"><div class="adv__top">ADVERTISEMENT</div><div class="adv__mast"><b>NUANSE</b> <i>STORIES</i></div>' +
        '<div class="adv__wrap"><article class="adv__col">' +
        "<h1>A small symbol of strength: the hummingbird jewellery so many women wear in memory of someone</h1>" +
        '<p class="adv__by"><span class="adv__av">N</span>By <b>the NUANSE team</b> · sponsored content</p>' +
        fig(gi(HB.p1), "Hummingbird earrings by a window") +
        "<p><b>The hummingbird appears in many stories as a messenger.</b> In several Latin American cultures, they say that when a hummingbird comes close, it's someone we love passing by.</p>" +
        "<p>That's why so many people choose these pieces for themselves or as a gift: they're light, colourful and carry a lovely idea, that the ones we love are still close.</p>" +
        fig(gi(HB.gif), "Hummingbird earrings catching the light") +
        "<p>The colours change with the light: reds, yellows, greens and blues, like the feathers of a real hummingbird.</p>" +
        fig(gi(HB.p1), "Hummingbird earrings by a window") +
        '<h2>Meet the <span class="adv__hl">Acrylic Hummingbird Earrings</span></h2>' +
        fig(gi(HB.p2), "Hummingbird earrings in a hand") +
        "<p>A hummingbird design in colourful acrylic, with metal hooks. They're very light, so you can wear them all day.</p>" +
        "<h2>As practical as they are pretty</h2>" +
        fig(gi(HB.p2), "Hummingbird earrings in a hand") +
        '<ul class="adv__list"><li>✔ Light: you barely feel them</li><li>✔ Colourful acrylic that keeps its colour with normal wear</li><li>✔ Ready to give as a gift</li><li>✔ 3-year guarantee</li></ul>' +
        cta(url, "SEE THE EARRINGS") +
        "<h2>A gift with meaning</h2>" +
        fig(NZ.about, "Woman working on a piece of jewellery") +
        "<p>For your mum, your nan, a friend going through a goodbye, or for you. A small gift that says a lot.</p>" +
        fig(gi(HB.box), "Hummingbird earrings") +
        "<h2>How they look day to day</h2>" +
        '<div class="adv__grid3">' + [HB.u1, HB.u2, HB.u3].map(function (x) { return '<img loading="lazy" src="' + gi(x, 500) + '" alt="">'; }).join("") + "</div>" +
        '<div class="adv__note">We don\'t have reviews of these earrings yet. When customers leave them, they\'ll appear here exactly as written.</div>' +
        "<h2>Buy today with the Buy 2 discount</h2>" +
        fig(gi(HB.p1), "") +
        '<p class="adv__price">' + price + " · <span>Buy 2 pieces and save 15%</span></p>" +
        "<p>Pair the earrings with a necklace, or get two pairs to give away. The discount appears automatically in your basket, and delivery is free on orders from " + M(NZL.FREE) + ".</p>" +
        cta(url, "SEE THE EARRINGS") +
        '<p class="adv__disc"><b>Please note:</b> this page is an advertisement by NUANSE. It is not a press article.</p>' +
        "</article>" +
        side(gi(HB.side, 600), "Acrylic Hummingbird Earrings", "Celebrate your strength with colour. " + price, url, "SEE THE EARRINGS") +
        "</div></div>";
    },
  };
  NZPAGES["/pages/contact"] = {
    render: function () {
      A().app.innerHTML =
        '<section class="sec page-width pg pg--form"><h1 class="pg__t">Contact</h1>' +
        '<form method="post" action="' + NZL.u("/contact") + '#contact_form" accept-charset="UTF-8" class="cf"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">' +
        '<label>Name<input name="contact[name]" autocomplete="name"></label>' +
        '<label>Email<input type="email" name="contact[email]" required autocomplete="email"></label>' +
        '<label>Message<textarea name="contact[body]" rows="6"></textarea></label>' +
        '<button class="btn btn--lg" type="submit">Send</button></form>' +
        '<p class="cf__note">We reply within 24 working hours. You can also email contacto@nuanse.online.</p></section>';
    },
  };
  NZPAGES["/pages/faq-frequently-asked-questions"] = {
    render: function () {
      var q = [
        ["What currency do I pay in?", "In pounds sterling (GBP). The price you see is the price you pay at checkout."],
        ["How long does delivery take?", "We process your order in 1 to 3 working days. Tracked delivery to the UK takes " + NZL.ETA[0] + " to " + NZL.ETA[1] + " working days in total, as the pieces are sent by our supplier from outside the UK. You'll get a tracking code by email."],
        ["How much is delivery?", M(NZL.SHIP) + " to the UK. Free on orders from " + M(NZL.FREE) + "."],
        ["How do I track my order?", "Use the link in your shipping email. If you can't find it, email us and we'll send it again."],
        ["What's your returns policy?", 'You have 30 days after it arrives to return it, no questions asked. See our <a href="' + NZL.u("/policies/refund-policy") + '" data-native>returns policy</a>.'],
        ["How do I contact you?", 'Email contacto@nuanse.online or use the <a href="/pages/contact" data-link>contact form</a>.'],
        ["Which payment methods do you accept?", "Card (Visa, Mastercard, Maestro, Amex), Apple Pay, Google Pay, PayPal and Klarna."],
        ["When will I get my refund?", "Within 14 days of us receiving your return, back to the same payment method."],
      ];
      page("FAQs", q.map(function (x) { return "<h3>" + x[0] + "</h3><p>" + x[1] + "</p>"; }).join(""));
    },
  };
  NZPAGES["/pages/leave-a-review"] = {
    render: function () {
      A().app.innerHTML =
        '<section class="sec page-width pg rv-page"><h2>We\'d love your honest opinion 💬</h2>' +
        "<p>Thank you for being part of NUANSE 💗<br>Your opinion helps us choose every piece better and helps other people decide.</p>" +
        "<p>✨ It takes less than a minute<br>✨ We publish every review, good and bad, exactly as written<br>✨ We only ask people who've bought from us</p>" +
        "<p>Did you love your piece, or do you think we could do better? We want to know.</p>" +
        '<a class="btn btn--lg" href="/pages/contact" data-link>Start your review →</a></section>';
    },
  };
  // a página real da Shopify é /pages/perguntas-frequentes; o link antigo dava 404 ao abrir direto
  if (window.NZPAGES && NZPAGES["/pages/faq-frequently-asked-questions"]) NZPAGES["/pages/perguntas-frequentes"] = NZPAGES["/pages/faq-frequently-asked-questions"];
})();
